import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PropsWithChildren, ReactElement } from 'react';

/** Section title that marks the section as not required to fill in. */
export const OptionalSectionTitle = (props: PropsWithChildren): ReactElement => {
    return (
        <Box component="span" sx={{ display: 'inline-flex', gap: 0.5, alignItems: 'baseline' }}>
            {props.children}
            <Box component="span" sx={{ opacity: 0.6, textTransform: 'none' }}>
                <FormattedMessage id="app.common.optionalSectionTitle" />
            </Box>
        </Box>
    );
};
